export default __webpack_public_path__ + "media/1898_logo.df94bd33.png";